import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useState, useContext, useEffect } from "react";
import { BsFillEyeFill, BsX } from "react-icons/bs";
import TextInput from "../../../components/InputComponents/TextInput";
import SelectInput from "../../../components/InputComponents/SelectInput";
import georgianCities from "../../../data/georgianCities";
import {
  successToast,
  errorToast,
} from "../../../adminPanel/components/toastAlerts/ToastAlerts";
import axiosClient from "../../../api/api";
import { PrimaryContext } from "../../../components/MainContext/MainContext";
import { Link } from "react-router-dom";

import policy from "../../../policy.pdf"
import { apiError } from "../../../api/apiError";

const Register = ({ setToggleRegistration }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [regCredentials, setRegCredentials] = useState({});
  const [type, setType] = useState("person");
  const { setToken, setUser, setIsAuthorized } = useContext(PrimaryContext);
  const [agree, setAgree] = useState(false);
  const [fillAll, setFillAll] = useState(false);
  const [allFilled, setAllFilled] = useState(false);
  const [confirmationCodeOk, setConfirmationCodeOk] = useState(false);
  const [emailCodeOk, setEmailCodeOk] = useState(false);
  // Which channel the code popup is for: null | "phone" | "email".
  const [codePopup, setCodePopup] = useState(null);
  const [promoCode, setPromoCode] = useState("");
  const [promoCodePassed, setPromoCodePassed] = useState(false);
  const [promoCodeId, setPromoCodeId] = useState(null);

  const handleType = (e) => {
    setRegCredentials({});
    setAgree(false);
    setFillAll(false);
    setType(e.target.value);
  };

  const handleCredentials = (value, inputName) => {
    setRegCredentials((prev) => ({
      ...prev,
      [inputName]: value,
    }));
    // A tick belongs to the value that was checked, not the field.
    if (inputName === "phone") setConfirmationCodeOk(false);
    if (inputName === "email") setEmailCodeOk(false);
  };

  // Signup verifies BOTH the phone (SMS) and the email (mail), and the server
  // refuses /signup unless each has been proven with its code. The popup only
  // opens once the gateway confirms it actually sent — opening it on a failed
  // send left people typing a code that was never delivered.
  const handleSendPhoneCode = () => {
    if (!regCredentials.phone) {
      errorToast(t("phone") + " ?");
      return;
    }
    axiosClient
      .get(`/sendPhoneVerify/${regCredentials.phone}`)
      .then(() => {
        successToast(t("sms_code_sent") || t("code_sent"));
        setCodePopup("phone");
      })
      .catch((err) => {
        errorToast(apiError(err, t("email_registerd_or_error")));
      });
  };

  const handleSendEmailCode = () => {
    if (!regCredentials.email) {
      errorToast(t("email_address") + " ?");
      return;
    }
    axiosClient
      .get(`/sendVerify/${encodeURIComponent(regCredentials.email.trim())}`)
      .then(() => {
        successToast(t("code_sent"));
        setCodePopup("email");
      })
      .catch((err) => {
        errorToast(apiError(err, t("email_registerd_or_error")));
      });
  };

  const handleSendCode = () => {
    const code = regCredentials.verificationCode;
    const req =
      codePopup === "email"
        ? axiosClient.get(`/verify/${encodeURIComponent(regCredentials.email.trim())}/${code}`)
        : axiosClient.get(`/verifyPhone/${regCredentials.phone}/${code}`);
    req
      .then(() => {
        if (codePopup === "email") setEmailCodeOk(true);
        else setConfirmationCodeOk(true);
        setCodePopup(null);
        handleCredentials("", "verificationCode");
        successToast(t("successfully"));
      })
      .catch((err) => {
        if (codePopup === "email") setEmailCodeOk(false);
        else setConfirmationCodeOk(false);
        errorToast(apiError(err, t("invalid_code_or_error")));
      });
  };

  const handleCheckPromoCode = () => {
    axiosClient
      .get(`promokodi/check/${promoCode}`)
      .then(({ data }) => {
        setPromoCodeId(data.id);
        setPromoCodePassed(true);
      })
      .catch((err) => {
        console.error(err);
        setPromoCodePassed(false);
        errorToast(t("promoCodeDoNotExits"));
      });
  };

  useEffect(() => {
    if (type === "person ") {
      regCredentials.fname !== "" &&
      regCredentials.fname !== null &&
      regCredentials.lname !== "" &&
      regCredentials.lname !== null &&
      regCredentials.fname_eng !== "" &&
      regCredentials.fname_eng !== null &&
      regCredentials.lname_eng !== "" &&
      regCredentials.lname_eng !== null &&
      regCredentials.email !== "" &&
      regCredentials.email !== null &&
      regCredentials.phone !== "" &&
      regCredentials.phone !== null &&
      regCredentials.person_id !== "" &&
      regCredentials.person_id !== null &&
      regCredentials.password !== "" &&
      regCredentials.password !== null &&
      regCredentials.password_confirmation !== "" &&
      regCredentials.password_confirmation !== null &&
      regCredentials.city !== "" &&
      regCredentials.city !== null &&
      regCredentials.address !== "" &&
      regCredentials.address !== null
        ? setAllFilled(true)
        : setAllFilled(false);
    } else {
      regCredentials.cname !== "" &&
      regCredentials.cname !== null &&
      regCredentials.cname_eng !== "" &&
      regCredentials.cname_eng !== null &&
      regCredentials.email !== "" &&
      regCredentials.email !== null &&
      regCredentials.phone !== "" &&
      regCredentials.phone !== null &&
      regCredentials.company_id !== "" &&
      regCredentials.company_id !== null &&
      regCredentials.password !== "" &&
      regCredentials.password !== null &&
      regCredentials.password_confirmation !== "" &&
      regCredentials.password_confirmation !== null &&
      regCredentials.city !== "" &&
      regCredentials.city !== null &&
      regCredentials.address !== "" &&
      regCredentials.address !== null
        ? setAllFilled(true)
        : setAllFilled(false);
    }
  }, [regCredentials]);

  useEffect(() => {
    if (type === "person ") {
      !(
        regCredentials.fname === "" ||
        regCredentials.lname === "" ||
        regCredentials.fname_eng === "" ||
        regCredentials.lname_eng === "" ||
        regCredentials.email === "" ||
        regCredentials.phone === "" ||
        regCredentials.person_id === "" ||
        regCredentials.password === "" ||
        regCredentials.password_confirmation === "" ||
        regCredentials.city === "" ||
        regCredentials.address === ""
      ) && setFillAll(true);
    } else {
      !(
        regCredentials.cname === "" ||
        regCredentials.cname_eng === "" ||
        regCredentials.email === "" ||
        regCredentials.phone === "" ||
        regCredentials.company_id === "" ||
        regCredentials.password === "" ||
        regCredentials.password_confirmation === "" ||
        regCredentials.city === "" ||
        regCredentials.address === ""
      ) && setFillAll(true);
    }
  }, [regCredentials]);

  const handleLoginApi = async () => {
    if (!emailCodeOk) {
      errorToast(t("verify_email_first") || "დაადასტურეთ ელფოსტა");
      return;
    }
    if (confirmationCodeOk) {
      if (agree) {
        if (fillAll) {
          if (
            regCredentials.password === regCredentials.password_confirmation
          ) {
            try {
              const res = await axiosClient.post(`/signup`, {
                ...regCredentials,
                ...(promoCodePassed && { promo_id: promoCodeId }),
              });
              if (res) {
                setToken(res.data.token);
                setUser(res.data.user);
                setIsAuthorized(true);
                successToast(t("successfully"));
                navigate("/registration-success");
              }
            } catch (error) {
              errorToast(apiError(error, t("email_or_already_registerd")));
            }
          } else {
            errorToast(t("passwords_dont_match"));
          }
        } else {
          errorToast(t("fill_all_fields"));
        }
      } else {
        errorToast(t("agree_terms"));
      }
    } else {
      errorToast(t("verify_phone_first") || "დაადასტურეთ ტელეფონის ნომერი");
    }
  };

  return (
    <div
      className="fixed top-0 left-0 w-full h-full bg-white bg-opacity-80 flex items-center justify-center z-50 md:p-0
    sm"
    >
      <div
        className="w-6/12 rounded-[30px] p-10 flex gap-2 flex-col items-start justify-start bg-white
            border-2 border-[#F0F0F0] shadow-sm relative md:w-full md:p-3 md:overflow-auto md:h-full
            md:rounded-none md:border-none"
      >
        <div className="flex justify-end w-full">
          <BsX
            className="cursor-pointer text-2xl text-red-500 md:right-5"
            onClick={() => {
              setToggleRegistration((prev) => !prev);
            }}
          />
        </div>
        <div className="w-full flex items-center justify-between sm:flex-col gap-2 sm:justify-start sm:items-start">
          <h6 className="text-2xl md:text-xl font-bold">{t("sign_up")}</h6>
          <div className="flex items-center gap-2">
            <div className="flex gap-1 items-center cursor-pointer">
              <input
                type="radio"
                id="person"
                name="choice"
                value={"person"}
                onChange={(e) => {
                  handleType(e);
                }}
                checked={type === "person"}
              />
              <label htmlFor="person" className="text-sm font-bold">
                {t("physical_person")}
              </label>
            </div>
            <div className="flex gap-1 items-center cursor-pointer">
              <input
                type="radio"
                id="company"
                name="choice"
                value={"company"}
                onChange={(e) => {
                  handleType(e);
                }}
                checked={type === "company"}
              />
              <label htmlFor="company" className="text-sm font-bold">
                {t("legal_entity")}
              </label>
            </div>
          </div>
        </div>
        {type === "person" ? (
          <>
            <div className="grid grid-cols-2 sm:grid-cols-1 mt-2 w-full gap-2">
              <TextInput
                name={t("name") + " " + t("georgian")}
                inputName={"fname"}
                inputSetter={handleCredentials}
                type="text"
                value={regCredentials.fname}
                style={2}
              />
              <TextInput
                name={t("surname") + " " + t("georgian")}
                inputName={"lname"}
                inputSetter={handleCredentials}
                type="text"
                value={regCredentials.lname}
                style={2}
              />
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-1 mt-2 w-full gap-2">
              <TextInput
                name={t("name_eng")}
                inputName={"fname_eng"}
                inputSetter={handleCredentials}
                type="text"
                value={regCredentials.fname_eng}
                style={2}
              />
              <TextInput
                name={t("surname_eng")}
                inputName={"lname_eng"}
                inputSetter={handleCredentials}
                type="text"
                value={regCredentials.lname_eng}
                style={2}
              />
            </div>
          </>
        ) : (
          <>
            <div className="grid grid-cols-2 sm:grid-cols-1 mt-2 w-full gap-2">
              <TextInput
                name={t("company_name")}
                inputName={"cname"}
                inputSetter={handleCredentials}
                type="text"
                value={regCredentials.cname}
                style={2}
              />
              <TextInput
                name={t("company_name_eng")}
                inputName={"cname_eng"}
                inputSetter={handleCredentials}
                type="text"
                value={regCredentials.cname_eng}
                style={2}
              />
            </div>
          </>
        )}
        <div className="grid grid-cols-1 mt-2 w-full gap-2">
          <div className="flex items-end gap-2">
            <TextInput
              name={t("email_address")}
              inputName={"email"}
              placeholder={"foxExample@gmail.com"}
              inputSetter={handleCredentials}
              type="text"
              value={regCredentials.email}
              style={2}
            />
            <button
              type="button"
              className={`rounded-[20px] text-white font-bold text-sm px-8 py-3 shrink-0 ${
                emailCodeOk ? "bg-green-600" : "bg-teal_600"
              }`}
              onClick={handleSendEmailCode}
              disabled={emailCodeOk}
            >
              {emailCodeOk ? "✓" : t("send_code") || "Send Code"}
            </button>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-1 mt-2 w-full gap-2">
          <div className="flex items-end gap-2">
            <TextInput
              name={t("phone")}
              inputName={"phone"}
              placeholder={"XXXXXXXXX"}
              inputSetter={handleCredentials}
              type="text"
              pattern={"number"}
              value={regCredentials.phone}
              style={2}
            />
            <button
              type="button"
              className={`rounded-[20px] text-white font-bold text-sm px-8 py-3 shrink-0 ${
                confirmationCodeOk ? "bg-green-600" : "bg-teal_600"
              }`}
              onClick={handleSendPhoneCode}
              disabled={confirmationCodeOk}
            >
              {confirmationCodeOk ? "✓" : t("send_code") || "Send Code"}
            </button>
          </div>
          {type === "person" ? (
            <div className="flex flex-col gap-2 items-start justify-start w-full">
              <TextInput
                name={t("personal_id")}
                inputName={"person_id"}
                inputSetter={handleCredentials}
                value={regCredentials.person_id}
                style={2}
              />
            </div>
          ) : (
            <div className="flex flex-col gap-1 items-start justify-start w-full">
              <TextInput
                name={t("company_id")}
                inputName={"company_id"}
                inputSetter={handleCredentials}
                type="number"
                value={regCredentials.company_id}
                style={2}
              />
            </div>
          )}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-1 mt-2 w-full gap-2 items-end">
          <TextInput
            name={`${t("password")} ${t("password_eight_character")}`}
            inputName={"password"}
            inputSetter={handleCredentials}
            type="password"
            value={regCredentials.password}
            SuffixIcon={BsFillEyeFill}
            style={2}
          />
          <TextInput
            name={`${t("password")} ${t("password_eight_character")}`}
            inputName={"password_confirmation"}
            inputSetter={handleCredentials}
            type="password"
            value={regCredentials.password_confirmation}
            SuffixIcon={BsFillEyeFill}
            style={2}
          />
        </div>
        {/* Home-delivery preparation: default address (city + street). */}
        <div className="w-full mt-3">
          <p className="text-xs text-gray-500 font-semibold mb-1">
            {t("home_delivery_hint") ||
              "მიტანის სერვისისთვის — მიუთითეთ თქვენი მისამართი"}
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-1 w-full gap-2">
            <SelectInput
              name={t("city") || "ქალაქი"}
              inputName={"city"}
              inputSetter={handleCredentials}
              options={georgianCities.map((c) => ({
                id: c.value,
                title: c.label,
              }))}
              value={regCredentials.city}
              style={2}
            />
            <TextInput
              name={t("address") || "მისამართი"}
              inputName={"address"}
              inputSetter={handleCredentials}
              type="text"
              value={regCredentials.address}
              style={2}
            />
          </div>
        </div>
        <TextInput
          name={t("promoCode")}
          inputName={"promo"}
          inputSetter={(value, key) => {
            setPromoCodeId(null);
            setPromoCodePassed(false);
            setPromoCode(value);
          }}
          style={2}
        />
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            onChange={(e) => {
              handleCredentials(e.target.checked, "online_shop");
            }}
            className="w-4 h-4 shrink-0"
          />
          <p className="text-sm text-left w-auto font-bold">
            {t("onlineShop")}
          </p>
        </div>
        <div className="flex gap-2 items-center w-full">
          <input
            type="checkbox"
            onChange={(e) => {
              setAgree(e.target.checked);
            }}
            className="w-4 h-4 shrink-0"
          />
          <p
            className={`text-sm text-left w-auto ${
              agree ? "text-teal_600" : "text-red-500"
            }`}
          >
            {t("agree_to_our")}{" "}
            <span className="underline underline-offset-8 font-bold">
              {" "}
              <Link to="/terms" target="_blank" rel="noreferrer">
                {t("terms_of_use")}
              </Link>{" "}
            </span>
            {t("and")}{" "}
            <span className="underline underline-offset-8 font-bold">
              <a target="_blank" href={policy}>
                {t("privacy_policy")}
              </a>
            </span>
          </p>
        </div>
        <div className="flex flex-col items-start gap-5 mt-5 w-full sm:gap-2">
          {promoCode && !promoCodePassed ? (
            <button
              className="rounded-[20px] text-white font-bold bg-teal_600 text-sm px-10 py-3 shrink-0"
              onClick={handleCheckPromoCode}
            >
              {t("checkPromoCode")}
            </button>
          ) : (
            <button
              className="rounded-[20px] text-white font-bold bg-teal_600 text-sm px-10 py-3 shrink-0"
              onClick={handleLoginApi}
            >
              {t("sign_up")}
            </button>
          )}
        </div>
      </div>

      {codePopup && (
        <div
          className="w-screen h-screen bg-white bg-opacity-80 flex items-center justify-center 
        fixed top-0 left-0 z-50"
        >
          <div
            className="bg-white flex flex-col gap-5 w-[50%] md:w-[90%] p-10
            border-2 border-[#F0F0F0] shadow-sm rounded-[30px] relative"
          >
            <BsX
              onClick={() => {
                setCodePopup(null);
              }}
              className="absolute top-5 right-5 text-gray-400 w-6 h-6 cursor-pointer"
            />
            <p className="text-sm text-slate-600">
              {codePopup === "email"
                ? `${t("code_sent")}: ${regCredentials.email}`
                : `${t("sms_code_sent") || t("code_sent")}: ${regCredentials.phone}`}
            </p>
            <div className="flex items-center gap-2 sm:flex-wrap">
              <TextInput
                name={codePopup === "email" ? t("email_code") || "კოდი წერილიდან" : t("sms_code") || "SMS კოდი"}
                inputName={"verificationCode"}
                inputSetter={handleCredentials}
                type="text"
                value={regCredentials.verificationCode || ""}
                style={2}
              />
              <button
                className="rounded-[20px] text-white font-bold bg-teal_600 text-sm px-10 py-3 shrink-0"
                onClick={handleSendCode}
              >
                {t("confirm_code") || "დადასტურება"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Register;
